module.exports = __webpack_public_path__ + "img/horizontal_3_2_r_pp2_9005.25f34bb4.png";